import { CCard, CCardTitle, CCol, CRow } from "@coreui/react";
import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { notify } from "src/functions/function";
import { COLORS } from "../../constants/Colors";
import {
  createNewPlacements,
  extractAndSetPlacements,
  updatePlacements,
  fetchPlacementsFromOurServer,
} from "./DataHandlers";
import EmployeeList from "./EmployeeList";
import LogList from "./LogList";

const DataSavvy = ({
  apiKey,
  apiPassword,
  companyId,
  handlerId,
  isLoading,
  employees = [],
  clients = [],
  placements = [],
  userToken,
  dispatch,
}) => {
  const [state, setState] = useState({
    successLogs: [],
    errorLogs: [],
    loading: false,
    placements,
  });

  useEffect(() => {
    setState((state) => ({
      ...state,
      placements,
    }));
  }, [placements]);

  /* Use callback to set state. */
  const addLog = (type, log) => {
    if (type === "SUCCESS") {
      setState((s) => ({ ...s, successLogs: [...s.successLogs, log] }));
    } else {
      setState((s) => ({ ...s, errorLogs: [...s.errorLogs, log] }));
    }
  };

  /* 
  * The engine to setup the dataSavvy extraction.
  1. Create a map of employee Id's vs their assigned placements in our system.
  2. For each employee in the selected array, pull the employee's placements from DataSavvy.
  3. Compare -> If it exists
  */
  const handleServerUpdate = async (selectedEmployees) => {
    if (state.loading || isLoading) {
      // Prevents multiple clicks.
      return;
    }

    setState((state) => ({
      ...state,
      loading: true,
      successLogs: [...state.successLogs, "Commencing DataSavvy Merge"],
    }));

    /* Fetch before updating to handle concurrency issues. The server will force queuing */
    var serverPlacements = [];
    try {
      addLog(
        "SUCCESS",
        "Pulling placements from our server to prevent concurrency issues."
      );
      serverPlacements = await fetchPlacementsFromOurServer(userToken);
      addLog("SUCCESS", "Pulling from our server complete.");
    } catch {
      notify("Error", "There was an error. Please try again!", "danger");
      setState((s) => ({ ...state, loading: false }));
      return;
    }

    const [POST, PUT] = await extractAndSetPlacements(
      selectedEmployees,
      clients,
      serverPlacements,
      apiKey,
      apiPassword,
      companyId,
      handlerId,
      addLog
    );

    if (!POST?.length && !PUT?.length) {
      setState((state) => ({ ...state, loading: false }));
      addLog("SUCCESS", "There were no placements to update or create");
      return;
    }

    if (POST?.length) {
      await createNewPlacements(POST, userToken, addLog);
    }
    if (PUT?.length) {
      await updatePlacements(PUT, userToken, addLog);
    }

    setState((s) => ({ ...s, loading: false }));
  };

  return (
    <>
      <CRow className="">
        <CCol>
          <button
            type="button"
            class="btn btn-success justify-self-center"
            style={{ color: COLORS.WHITE }}
            onClick={() => {
              handleServerUpdate(employees);
            }}
          >
            Fetch all placements from DataSavvy{"  "}
            {state.loading ? (
              <div
                class="spinner-border spinner-border-sm text-white align-self-center"
                role="status"
              >
                <span class="sr-only">Loading...</span>
              </div>
            ) : null}
          </button>
          {isLoading || state.loading ? (
            <>
              <div class="" role="status"></div>
              <div class="row pt-2 pl-1 align-items-center">
                <div class="col-0.5">
                  <div
                    class="spinner-border spinner-border-sm ml-3"
                    role="status"
                  >
                    <span class="sr-only">Loading...</span>
                  </div>
                </div>
                <div class="col-6" color={COLORS.textInputGrey}>
                  <i>
                    Pulling placements from our server to prevent concurrency
                    issues...
                  </i>
                </div>
              </div>
            </>
          ) : null}
        </CCol>
      </CRow>
      <CRow>
        <CCol className="h-100">
          <CCardTitle className="d-flex justify-content-center pt-4 pb-2 m-0">
            {" "}
            Success Logs
          </CCardTitle>
          <LogList logs={state.successLogs} textColor="text-success" />
        </CCol>
        <CCol className="h-100">
          <CCardTitle className="d-flex justify-content-center pt-4 pb-2 m-0">
            {" "}
            Error Logs
          </CCardTitle>
          <LogList logs={state.errorLogs} textColor="text-danger" />
        </CCol>
        <CCol className="h-100 col-3">
          <CCard className="p-0" style={{ height: "90%", width: "100%" }}>
            <CCardTitle className="d-flex justify-content-center border-bottom pt-4 pb-4 m-0">
              {" "}
              Employees
            </CCardTitle>
            <EmployeeList
              employees={employees}
              handleServerUpdate={handleServerUpdate}
            />
          </CCard>
        </CCol>
      </CRow>
    </>
  );
};

function mapStateToProps(state) {
  return {
    employees: state.userPlacementsReducer.employees,
    clients: state.userPlacementsReducer.clients,
    placements: state.userPlacementsReducer.incompletePlacements,
    isLoading: state.userPlacementsReducer.isLoading,
    userToken: state.userTokenReducer.userToken,
    apiKey: state.userTokenReducer.userData.handler.dataSavvy_api_key,
    apiPassword: state.userTokenReducer.userData.handler.dataSavvy_api_password,
    companyId: state.userTokenReducer.userData.handler.dataSavvy_company_id,
    handlerId: state.userTokenReducer.userData.handler.id,
  };
}

export default connect(mapStateToProps)(DataSavvy);
